import { Controller } from 'react-hook-form'
import { TextInput } from '../../inputs'
import { Search } from '@mui/icons-material'
import { useI18n } from '@ggs/i18n'

/**
 * @typedef {import('react-hook-form').FieldErrors} FieldErrors
 * @typedef {import('react-hook-form').FieldValues} FieldValues
 * @typedef {import('react-hook-form').Control<FieldValues>} FormControl
 */

/**
 * @typedef {Object} KeywordFilterProps
 * @property {FieldErrors} errors
 * @property {FormControl} control
 */

/**
 * Provides keyword field form element.
 * @param {KeywordFilterProps} props
 * @return {JSX.Element}
 */
const KeywordField = ({ control, errors }) => {
  const { t } = useI18n()
  const errorMessage = errors.searchTerm?.message
  const hasError = Boolean(errors.searchTerm)
  return (
    <Controller
      control={control}
      name="searchTerm"
      defaultValue=""
      render={({ field }) => (
        <TextInput
          id="form-quick-search-keyword"
          label={t('Quick Start: Keyword Search')}
          labelClasses={{
            root: 'quick-search-form__form-field-label',
          }}
          placeholder={t('What kind of service are you looking for?')}
          error={hasError}
          // @ts-ignore
          errorHelperText={errorMessage}
          // @ts-ignore
          startIcon={<Search color="tertiary" />}
          inputProps={{
            type: 'search',
            spellCheck: 'true',
          }}
          inputFields={{
            autoComplete: 'off',
            ...field,
          }}
        />
      )}
    />
  )
}

export default KeywordField
